import React, { Fragment, PureComponent } from 'react';
import cn from 'classnames';
import type { IProps as ITextV2Props } from '@alfa-bank/site-text-v2/src/models';
import type { IStyler } from '@alfa-bank/site-util-create-widget/src/models';

import type { TBreadcrumbsComponent } from './models';
import { ICON_SIZE } from './config';

export class Breadcrumbs extends PureComponent<TBreadcrumbsComponent> {
    render() {
        const {
            Icon,
            Link,
            Text,
            className,
            collapseCount = 2,
            collapsed = false,
            getPaths,
            paths,
            styles,
            theme = 'white',
        } = this.props;

        const newPaths = getPaths({
            paths,
            collapsed,
            collapseCount,
        });

        const separatorClass = cn(styles.separator, styles.external, {
            [styles.blueTheme]: theme === 'blue',
        });

        const textProps: ITextV2Props = {
            view: 'component-secondary',
            theme: theme === 'white' ? 'light' : 'dark',
        };

        const stylerProp: IStyler = {
            marginTop: 0,
            marginBottom: 0,
        };

        return (
            <div className={cn(styles.container, className)}>
                {newPaths.map(({ id, link, title }, index) => (
                    <Fragment key={id}>
                        <Text
                            className={cn(styles.inline, styles.external)}
                            {...textProps}
                            {...stylerProp}
                        >
                            {link ? (
                                <Link href={link} theme={theme}>
                                    {title}
                                </Link>
                            ) : (
                                <>{title}</>
                            )}
                        </Text>

                        {index < newPaths.length - 1 && (
                            <Icon
                                className={separatorClass}
                                height={ICON_SIZE.HEIGHT}
                                width={ICON_SIZE.WIDTH}
                            />
                        )}
                    </Fragment>
                ))}
            </div>
        );
    }
}
